
export const YoutubeEmbed = ({ url }: {url: string}) => (
  <div className="video-responsive">
    <iframe referrerPolicy="no-referrer-when-downgrade" width="891" height="501" src={`https://www.youtube.com/embed/${url}`} title="Alec Benjamin - Devil Doesn't Bargain [Official Audio]" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
  </div>
);